module.exports = __webpack_public_path__ + "static/media/cms.17a1dc34.svg";